import { useState } from 'react';
import { MessageContainerKey, MessageManager, MessageOptions } from '../message';
import { convertOldNotificationOptions } from './converter.old';
import type { NotificationComponentProps } from './Notification.old';

interface NotificationType {
  show: (props: MessageOptions<NotificationComponentProps>) => void;
  destroy: (id: string, key?: MessageContainerKey) => void;
}

export function useNotification() {
  const [notification] = useState<NotificationType>(() => {
    if (typeof window === 'undefined') {
      return { show: () => {}, destroy: () => {} };
    }
    const notification_instance = MessageManager.getInstance('notification');
    notification_instance.setInstance = {
      default_max_count: 3,
      default_offset: 16,
      default_position: 'top-right',
    };
    return {
      show: (props) => notification_instance.show(convertOldNotificationOptions(props)),
      destroy: (id, key) => notification_instance.destroy(id, key),
    };
  });

  return notification;
}
